import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    paddingTop: theme.spacing(8),
  },
}));

export default useStyles;
